import { DropdownButtonType, List, ListItem, ListProps, SingleSelectDropdown } from '@tableau/widgets';
import React from 'react';
import { CommonStyles } from '../../common/react/CommonStyles';
import { IViewInfo } from '../../ts/models/IViewInfo';

interface DevicePreviewNavigationToolsState {
  currentViewIndex: number;
}

export interface DevicePreviewNavigationToolsProps {
  viewList: IViewInfo[];
  startingViewIndex: number;
  onNewViewSelected: (newView: IViewInfo) => void;
}

export class DevicePreviewNavigationTools extends React.Component<DevicePreviewNavigationToolsProps, DevicePreviewNavigationToolsState> {
  private sizeStyling: React.CSSProperties = {
    maxWidth: 225,
    fontSize: 14
  };

  private textStyling: React.CSSProperties = {
    fontWeight: 'normal',
    color: CommonStyles.Colors.Grey230,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    ...this.sizeStyling
  };

  public state: DevicePreviewNavigationToolsState = {
    currentViewIndex: this.props.startingViewIndex
  };

  public render(): JSX.Element {
    if (this.props.viewList === undefined || this.props.viewList.length === 0) {
      return null;
    }

    const value = this.props.viewList[this.state.currentViewIndex].name;

    const listProps: ListProps = {
      items: this.getListItemsFromViews(),
      selectedValue: value
    };

    const dropdownProps = {
      list: <List {...listProps} style ={this.sizeStyling} />,
      onChange: this.onDropdownValueChanged,
      type: DropdownButtonType.Text,
      useDarkStyling: true,
      value: value,
      testId: 'device-preview-dropdown-control',
      label: ''
    };

    return (
      <span className="tb-preview-navigation-tools-container">
        <SingleSelectDropdown {...dropdownProps}>
          <span style={this.textStyling}>{ value }</span>
        </SingleSelectDropdown>
      </span>
    );
  }

  private getListItemsFromViews = (): ListItem[] => {
    return this.props.viewList.map((item) => {
      return {
        value: item.name,
        testId: `device-preview-view-list-item-${item.name}`
      };
    });
  }

  private onDropdownValueChanged = (newValue: string) => {
    const newIndex = this.props.viewList.findIndex(view => view.name === newValue);
    this.setState({ currentViewIndex: newIndex });
    this.props.onNewViewSelected(this.props.viewList[newIndex]);
  }
}
